// utils/auth.ts
export const LOCAL_STORAGE_KEYS = {
  isLoggedIn: 'isStudentLoggedIn',
  userType: 'StudentUserType',
  intendedVideoPath: 'intendedVideoPath',
};
